let language = {
    HEADER_CATALOG_TEXT: "Catalog",
    HEADER_PRODUCT_TEXT: "Product",
    HEADER_CASE_STUDY:"Case Study",
    HEADER_CUSTOM_CARD:"Custom Card",
    HEADER_CARD_GAME:"Card Game",
    HEADER_TRADING_CARD_GAME:"Trading Card Game (TCG)",
    HEADER_CUSOM_PLAYING_CARDS:"Cusom Playing Cards",
    HEADER_CUSTOM_TAROT_CARDS:"Custom Tarot Cards",
    HEADER_ORACLE_CARD:"Oracle Card",
    HEADER_TRADINF_CARD:"Trading Card",
    HEADER_CUSTOM_PUZZLE:"Custom Puzzle",
    HEADER_ART_AND_PHOTOGRAPHY:"Art and Photography",
    HEADER_BLOG:"Blog",
    HEADER_CONTACT_US:"Contact Us",
    HEADER_PLATFORM:"Platform",
    HEADER_PLATFORM_SHOPIFY:"Shopify",
    HEADER_PLATFORM_WOO:"WooCommerce",
    HEADER_PLATFORM_SNAPSHOP:"Snapshop",
    HEADER_SOLUTION:"Solution",
    HEADER_TRADING_CARD:"Trading Card",
    HEADER_SOLUTION_LICENSEE:"Licensee",
    HEADER_SOLUTION_IP:"IP(Intellectual Property)",
    HEADER_SIGN_UP:"Sign up",
    HEADER_SIGN_IN:"SIGN IN",
    HEADER_SIGN_OUT:"Sign Out",
    HEADER_LOGIN:"Login",
    HEADER_DASHBOARD:"Dashboard",
    HEADER_HOME_PAGE:"HomePage",
    HEADER_SELL_WITH_US:"Sell With Us",
    HEADER_BULK_ORDER_DISCOUNT:"Bulk Order Discount",
    HEADER_PREFERENCE_CURRENCY:"Currency",
    HEADER_GET_USER_CURRENCY_ERROR_TITLE: "Parameter Error",
};

export { language }